import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import List from "./list";
import Create from "./create";

class Post extends Component {
  render() {
    return (
      <Switch>
        <Route
          path="/post/create"
          render={(props) => <Create type="create" {...props} />}
        />
        <Route
          path="/post/update/:slug"
          render={(props) => <Create type="update" {...props} />}
        />
        <Route path="/post/list" render={(props) => <List {...props} />} />
      </Switch>
    );
  }
}
export default Post;
